import createMuiTheme from './createMuiTheme';
var defaultTheme = createMuiTheme();
export default defaultTheme;